import ListOption from "../../../ListOption";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentQueryPopularValueObject} from "../../../../data/value-object/content/ContentQueryPopularValueObject";
import {ContentQueryPopularSearchOption} from "../../../../data/search-option/content/ContentQueryPopularSearchOption";
import {SearchIndex} from "../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../ListPageWrapper";
import {ContentQueryPopularIO} from "../../../../io/ContentIO";
import {ContentQueryPopularDescription} from "../../../../data/description/content/ContentQueryPopularDescription";
import {ContentQueryPopularDescriptor} from "../../../../data/descriptor/content/ContentQueryPopularDescriptor";
import {
    ContentQueryPopularSearchOptionDescription
} from "../../../../data/description/content/ContentQueryPopularSearchOptionDescription";
import {
    applyContentQueryPopularSearchOption,
    ContentQueryPopularSearchOptionField
} from "../../../search-option-field/content/ContentQueryPopularSearchOptionField";
import ListOrder from "../../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentQueryPopularValueObject[]>([])
    const option = useStatePair<ContentQueryPopularSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentQueryPopularIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentQueryPopularDescription}
                descriptor={ContentQueryPopularDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/queries/populars/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentQueryPopularSearchOptionDescription}
                fields={ContentQueryPopularSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentQueryPopularSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentQueryPopularDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}